export default {
  submit: {
    id: 'report_illicit_content_submit',
    defaultMessage: 'Submit report',
  },

  submitErrorTitle: {
    id: 'report_illicit_content_submit_error_title',
    defaultMessage: 'We could not submit your report.',
  },

  submitErrorDescription: {
    id: 'report_illicit_content_submit_error_description',
    defaultMessage: 'Please try again.',
  },
  uploadErrorTitle: {
    id: 'report_illicit_content_upload_error_title',
    defaultMessage: 'We could not add your supporting files.',
  },
  uploadErrorDescription: {
    id: 'report_illicit_content_upload_error_description',
    defaultMessage: 'Check the files and try submitting your report again.',
  },

  continue: {
    id: 'report_illicit_content_continue',
    defaultMessage: 'Continue',
  },

  back: {
    id: 'report_illicit_content_back',
    defaultMessage: 'Back',
  },

  stepperAltBack: {
    id: 'report_illicit_content_stepper_alt_back',
    defaultMessage: 'Go back to the previous step',
  },

  stepperAltClose: {
    id: 'report_illicit_content_stepper_alt_close',
    defaultMessage: 'Close the form',
  },

  stepperAltCompleted: {
    id: 'report_illicit_content_stepper_alt_completed',
    defaultMessage: 'Completed step',
  },

  stepperAltCurrent: {
    id: 'report_illicit_content_stepper_alt_current',
    defaultMessage: 'Current step',
  },
}
